import React, { useState } from 'react'
import AdminPurchaseEntryNew from './AdminPurchaseEntryNew'
import AdminInvoiceEntryNew from './AdminInvoicEntryNew';
import QuotationNew from './QuotationNew';

const quotationDefaultValues = {
    skus: [],
    paymentTypes: [],
    quotationNumber:"",
    quotationDate: new Date().toISOString().split("T")[0],
    customerName:"",
    Mobile:"",
    TotalFineGold:"",
    advanceamount:"",
    balanceamount:""
  
  };

  
const AdminCreateQuotationEntryNew = () => {
  const [editStatus,setEditStatus] = useState(false)


  

  return (
    <>
    
   <QuotationNew
   editStatus={editStatus}
   defaultValues={quotationDefaultValues}
   />


   {/* <QuotationNew
   
    editStatus={editStatus}
    defaultValues={inoviceDefaultValues}
   /> */}
   
   </>
  )
}

export default AdminCreateQuotationEntryNew
